import { IGlass } from '@/data/glass'
import { IGlassType } from '@/data/glass-type'
import GlassOption from '@/data/glass-option'
import GlassOptionValue from '@/data/glass-option-value'
export interface ICartItem {
  id: string
  dneye?: boolean | null
  framePrice: number
  extraPrice: number
  extraPriceTitle: string
  glasses: IGlass
  impressionist?: boolean | null
  optionPrice: number
  price: number
  displayGlassPrice: number
  displayPrice: number
  displayFramePrice: string
  discountPrice: number
  type?: IGlassType
  index: number
}

export default class CartItem implements ICartItem {
  public index: number = 0
  public id!: string
  public dneye: boolean | null = null
  public framePrice: number = 0
  public extraPrice!: number
  public extraPriceTitle: string = ''
  public glasses!: IGlass
  public impressionist: boolean | null = null
  public type?: IGlassType | undefined
  constructor (glasses: IGlass) {
    this.glasses = glasses
    let initialType
    if (this.glasses.glassTypes) {
      this.glasses.glassTypes.forEach((glassType) => {
        if (glassType.isDefault) {
          initialType = glassType
        }
      })
      if (!initialType) {
        initialType = this.glasses.glassTypes[Math.floor(this.glasses.glassTypes.length / 2)]
      }
      this.type = initialType
    }
  }
  public get optionPrice (): number {
    let optionPrice = 0.0
    if (this.type) {
      this.type.options.forEach((option: GlassOption) => {
        option.values.map((optionValue: GlassOptionValue) => {
          if (optionValue.selected) {
            optionPrice += optionValue.price
          }
        })
      })
    }
    return optionPrice
  }

  public get displayFramePrice (): string {
    if (this.framePrice) {
      if (this.framePrice > 0) {
        return this.framePrice.toString()
      }
      return ''
    }
    return ''
  }

  public set displayFramePrice (value: string) {
    this.framePrice = parseFloat(value)
  }

  public get defaultOptionPrice (): number {
    let defaultTotalPrice = 0.0
    if (this.type) {
      this.type.options.forEach((option: GlassOption) => {
        option.values.map((optionValue: GlassOptionValue) => {
          if (optionValue.isDefault) {
            defaultTotalPrice += optionValue.price
          }
        })
      })
    }
    return defaultTotalPrice
  }

  private get hasDiscount (): boolean {
    if (this.discountPrice > 0) {
      return true
    }
    return false
  }

  public get displayGlassPrice (): number {
    let price = 0
    if (this.type) {
      price = this.type.price
    }
    return price
  }

  public get displayPrice (): number {
    let price = this.price
    if (this.discountPrice > 0) {
      price = this.discountPrice
    }
    return price
  }

  public get displayDiscountPrice (): number {
    let discount = 0.0
    let frame = 0.0
    let extra = 0.0

    // check frame
    if (this.framePrice && this.framePrice > 0) {
      frame = this.framePrice
    }

    if (this.extraPrice && this.extraPrice > 0) {
      extra = this.extraPrice
    }

    if (this.type) {
      if (this.index > 0) { // most expensive glass is first
        if (this.type.discountPercentage && this.type.discountPercentage > 0) { // global percentage
          const cleanPrice = (this.price - (frame + extra)) // discount without frame and extras
          discount = cleanPrice - (cleanPrice * (this.type.discountPercentage / 100))
        } else if (this.type.discountPrice) {
          discount = this.type.discountPrice
        }

        if (this.type.priceType === 1) {
          discount = discount / 2
        }

        discount += frame // add frame
        discount += extra // add extra
      }
    }
    return discount
  }

  public get discountPrice (): number {
    let discount = 0.0
    let frame = 0.0
    let extra = 0.0

    // check frame
    if (this.framePrice && this.framePrice > 0) {
      frame = this.framePrice
    }

    if (this.extraPrice && this.extraPrice > 0) {
      extra = this.extraPrice
    }

    if (this.type) {
      if (this.index > 0) { // most expensive glass is first
        if (this.type.discountPercentage && this.type.discountPercentage > 0) { // global percentage
          const cleanPrice = (this.price - (frame + extra)) // discount without frame and extras
          discount = cleanPrice - (cleanPrice * (this.type.discountPercentage / 100))
        } else if (this.type.discountPrice) {
          discount = this.type.discountPrice
        }
        discount += frame // add frame
        discount += extra // add extra
      }
    }
    return discount
  }

  public get price (): number {
    let price = 0.0
    // base price
    if (this.type) {
      price += this.type.price
    }

    // price += this.defaultOptionPrice
    // add options
    price += this.optionPrice
    if (this.type && this.type.priceType === 1) {
      price = price * 2
    }
    // frame
    if (this.framePrice) {
      price += this.framePrice
    }
    // extra
    if (this.extraPrice) {
      price += this.extraPrice
    }
    console.log(price)
    return price
  }

  public get selectedOptions (): GlassOption[] {
    if (this.type) {
      return this.type.options
        .filter((option: GlassOption) => (option.values.some((value: GlassOptionValue) => (value.selected))))
    }
    return []
  }

  public setFramePrice (price: string) {
    this.framePrice = parseFloat(price)
  }

  public setExtraPrice (price: string) {
    this.extraPrice = parseFloat(price)
  }

  public setExtraPriceTitle (title: string) {
    this.extraPriceTitle = title
  }
}
